// Module
var code = `<sub-header header="'Depository accounts'" tab="true">
  <a class="sub-header__create-button btn btn-primary"
     command-access="CreateDepositoryAccount"
     ng-href="#!/admin/organization/depository-accounts/create">
    Create new
  </a>
  <a class="sub-header__create-button btn btn-primary"
     ng-href="#!/admin/organization/depository-accounts/categories">
    See list of categories
  </a>
</sub-header>

<table class="products-table table" at-table at-list="\$ctrl.accounts">
  <thead></thead>
  <tbody class="tbody">
  <tr class="products-table__row">
    <td at-title="No">
      {{\$index+1+'.'}}
    </td>
    <td at-title="Branch">{{item.branchName}}</td>
    <td at-title="Account name">{{item.accountName}}</td>
    <td at-title="Account type">{{item.accountType | prettyEnum}}</td>
    <td at-title="Term">{{item.term}}</td>
    <td at-title="Amount">{{item.amount | nxCurrency}}</td>
    <td at-title="Account number">{{item.accountNumber}}</td>
    <td at-title="BRSTN">{{item.brstn}}</td>
    <td at-title="Clearing">{{item.clearing | prettyBoolean}}</td>
    <td at-title="Ledger account code">{{item.ledgerAccountCode}}</td>
    <td at-title="Date opened">{{item.dateOpened | prettyDate}}</td>
    <td at-title="Maturity date">{{\$ctrl.calculateMaturityDate(item) | prettyDate}}</td>
    <td class="summary-actions">
      <button class="products-table__item-edit btn btn-danger"
         command-access="DeleteDepositoryAccount"
         ng-click="\$ctrl.delete(item.id)">
        Delete
      </button>
      <button class="products-table__item-edit btn btn-warning"
         command-access="UpdateDepositoryAccount"
         ng-click="\$ctrl.update(item.id)">
        Update
      </button>
    </td>
  </tr>
  </tbody>
</table>

<div ng-if="!\$ctrl.accounts || !\$ctrl.accounts.length" class="empty-message">
  <span>No depository accounts found</span>
</div>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/depository-account/list/depository-account-list.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;